<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <contactWire-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></contactWire-add-form>
                <contactWire-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></contactWire-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import ContactWireAddForm from './forms/add/representations/WizardForm'
    import ContactWireUpdateForm from './forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../contactWireStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            ContactWireAddForm,
            ContactWireUpdateForm
        },

    }
</script>
